<section class="content public-registration">
  <div class="content-block">
    <div class="registration-shell">
      <div class="card card-doctor-profile">
        <div class="profile-content">
          <img class="profile-img" [src]="resolvedPanelImage" alt="Foto del Medico" />
          <div class="profile-text">
            <div class="profile-name">NUEVO MEDICO</div>
            <div class="profile-subtext">Complete la informacion requerida</div>
          </div>
        </div>
      </div>

      <div class="result-card" *ngIf="createdFolio">
        <div class="result-label">FOLIO</div>
        <div class="result-value">{{ createdFolio }}</div>
      </div>

      <div class="form-panel">
        <div class="card">
          <form [formGroup]="userForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>lock</mat-icon>
                DATOS DE ACCESO
              </div>
              <div class="descripcion-seccion">CREDENCIALES DEL USUARIO PARA ACCEDER AL SISTEMA</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>USUARIO</mat-label>
                    <input formControlName="usr" matInput required />
                  </mat-form-field>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('usr')?.hasError('required')" class="text-danger">EL NOMBRE DE USUARIO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('usr')?.hasError('pattern')" class="text-danger">SOLO LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUIONES BAJOS.</small>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="email" matInput required />
                  </mat-form-field>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('email')?.hasError('required')" class="text-danger">EL CORREO ELECTRONICO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('email')?.hasError('pattern')" class="text-danger">INGRESE UNA DIRECCION DE CORREO VALIDA.</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="userForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>person</mat-icon>
                DATOS PERSONALES
              </div>
              <div class="descripcion-seccion">INFORMACION GENERAL DEL MEDICO</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE(S)</mat-label>
                    <input formControlName="nombres" matInput required />
                  </mat-form-field>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('nombres')?.hasError('required')" class="text-danger">EL CAMPO NOMBRES ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('nombres')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PRIMER APELLIDO</mat-label>
                    <input formControlName="primerApellido" matInput required />
                  </mat-form-field>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('primerApellido')?.hasError('required')" class="text-danger">EL PRIMER APELLIDO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('primerApellido')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEGUNDO APELLIDO</mat-label>
                    <input formControlName="segundoApellido" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO MOVIL</mat-label>
                    <ngx-mat-intl-tel-input
                      formControlName="movil"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>
                  <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>{{ 'CODIGO POSTAL / COLONIA' | regionWord }}</mat-label>
                    <input
                      matInput
                      [matAutocomplete]="doctorAuto"
                      formControlName="settlementSearch"
                      (blur)="onDoctorSettlementBlur()" />
                    <mat-autocomplete
                      #doctorAuto="matAutocomplete"
                      [displayWith]="displaySettlement"
                      (optionSelected)="setSelectedDoctorSettlement($event.option.value)">
                      <mat-option *ngFor="let option of doctorSettlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea formControlName="domicilio" matInput required></textarea>
                  </mat-form-field>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('domicilio')?.hasError('required')" class="text-danger">EL DOMICILIO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('domicilio')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="doctorForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>medical_services</mat-icon>
                DATOS MEDICOS
              </div>
              <div class="descripcion-seccion">MATRICULA, COLEGIADO, UNIVERSIDAD, ESPECIALIDAD</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>MATRICULA GENERAL</mat-label>
                    <input formControlName="cedulaGeneral" matInput required />
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('cedulaGeneral')?.touched && doctorForm.get('cedulaGeneral')?.invalid" class="custom-error-below">
                    <small *ngIf="doctorForm.get('cedulaGeneral')?.hasError('required')" class="text-danger">LA MATRICULA GENERAL ES OBLIGATORIA.</small>
                    <small *ngIf="doctorForm.get('cedulaGeneral')?.hasError('pattern')" class="text-danger">LA MATRICULA GENERAL DEBE TENER 9 DIGITOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>COLEGIADO</mat-label>
                    <mat-select formControlName="colegiado" required>
                      <mat-option *ngFor="let option of colegiadoOptions" [value]="option.id">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>UNIVERSIDAD</mat-label>
                    <input formControlName="universidad" matInput required />
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('universidad')?.touched && doctorForm.get('universidad')?.invalid" class="custom-error-below">
                    <small *ngIf="doctorForm.get('universidad')?.hasError('required')" class="text-danger">LA UNIVERSIDAD ES OBLIGATORIA.</small>
                    <small *ngIf="doctorForm.get('universidad')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>ESPECIALIDAD</mat-label>
                    <input formControlName="especialidad" matInput />
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('especialidad')?.touched && doctorForm.get('especialidad')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>MATRICULA ESPECIALIDAD</mat-label>
                    <input formControlName="cedulaEspecialidad" matInput />
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('cedulaEspecialidad')?.touched && doctorForm.get('cedulaEspecialidad')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">LA MATRICULA DE ESPECIALIDAD DEBE TENER HASTA 9 DIGITOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>HORARIO</mat-label>
                    <input formControlName="horario" matInput required />
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('horario')?.touched && doctorForm.get('horario')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL HORARIO ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="branchForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>store</mat-icon>
                {{ ('DATOS DE LA SUCURSAL' | regionWord) }}
              </div>
              <div class="descripcion-seccion">{{ branchSectionDescription | regionWord }}</div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE DEL {{ branchEntityLabel }}</mat-label>
                    <input formControlName="nombre" matInput required />
                  </mat-form-field>
                  <div *ngIf="branchForm.get('nombre')?.touched && branchForm.get('nombre')?.invalid" class="custom-error-below">
                    <small *ngIf="branchForm.get('nombre')?.hasError('required')" class="text-danger">EL NOMBRE ES OBLIGATORIO.</small>
                    <small *ngIf="branchForm.get('nombre')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>REGISTRO SANITARIO</mat-label>
                    <input formControlName="registroSanitario" matInput required />
                  </mat-form-field>
                  <div *ngIf="branchForm.get('registroSanitario')?.touched && branchForm.get('registroSanitario')?.invalid" class="custom-error-below">
                    <small *ngIf="branchForm.get('registroSanitario')?.hasError('required')" class="text-danger">REGISTRO SANITARIO ES OBLIGATORIO.</small>
                    <small *ngIf="branchForm.get('registroSanitario')?.hasError('pattern')" class="text-danger">FORMATO EJ: ABC-123456-XYZ.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>{{ 'CODIGO POSTAL / COLONIA' | regionWord }}</mat-label>
                    <input
                      matInput
                      [matAutocomplete]="branchAuto"
                      formControlName="settlementSearch"
                      (blur)="onBranchSettlementBlur()" />
                    <mat-autocomplete
                      #branchAuto="matAutocomplete"
                      [displayWith]="displaySettlement"
                      (optionSelected)="setSelectedBranchSettlement($event.option.value)">
                      <mat-option *ngFor="let option of branchSettlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('settlementSearch')?.touched && branchForm.get('settlementSearch')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea formControlName="domicilio" matInput required></textarea>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('domicilio')?.touched && branchForm.get('domicilio')?.invalid" class="custom-error-below">
                    <small *ngIf="branchForm.get('domicilio')?.hasError('required')" class="text-danger">EL DOMICILIO ES OBLIGATORIO.</small>
                    <small *ngIf="branchForm.get('domicilio')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>badge</mat-icon>
                DATOS DEL RESPONSABLE SANITARIO
              </div>
              <div class="descripcion-seccion">SE LLENAN AUTOMATICAMENTE CON LOS DATOS DEL MEDICO</div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE</mat-label>
                    <input formControlName="responsable" matInput required readonly />
                  </mat-form-field>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="emailResponsable" matInput required readonly />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>MATRICULA</mat-label>
                    <input formControlName="cedulaResponsable" matInput required readonly />
                  </mat-form-field>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>TELEFONO</mat-label>
                    <input matInput [value]="responsiblePhoneDisplay" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="assetsForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>settings</mat-icon>
                CONFIGURACION
              </div>
              <div class="descripcion-seccion">ARCHIVOS DE USUARIO</div>

              <label class="upload-label">IMAGEN DE PERFIL (JPG, PNG, JPEG)</label>
              <app-file-upload
                formControlName="imagen"
                [acceptedTypes]="'image/*'"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320">
              </app-file-upload>

              <label class="upload-label">FIRMA DIGITAL (JPG, PNG, JPEG)</label>
              <app-file-upload
                formControlName="firma"
                [acceptedTypes]="'image/*'"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320">
              </app-file-upload>
            </div>

            <div class="seccion-formulario">
              <app-privacy-policies-consent
                formControlName="politicasPrivacidad"
                profileType="MEDICO">
              </app-privacy-policies-consent>
            </div>

            <button
              class="button-custom"
              mat-button
              color="primary"
              [disabled]="submitting || userForm.invalid || branchForm.invalid || doctorForm.invalid"
              [ngClass]="{
                'disabled': submitting || userForm.invalid || branchForm.invalid || doctorForm.invalid
              }"
              (click)="submit()">
              {{ submitting ? 'ENVIANDO...' : 'REGISTRARME' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
